import React, { useState, useEffect, useCallback, memo } from "react";

import { EntryOption, OptionList, OptionFooter } from "components/EntryOption";
import { BackToAnchorButton } from "basics/buttons";
import OptionLoader from "loader/SquareLoader";
import useEntryForm from "hooks/useEntryForm";
import useScroll from "hooks/useScroll";

export function InternalAwards({ topic, onBack, onSelected }) {
  const [awards, setAwards] = useState([]);
  const { scrollRef, scrollToRef } = useScroll();
  const { loadingAwards, getAwards } = useEntryForm();

  const handleAwards = useCallback(() => {
    if (topic !== undefined) {
      getAwards(topic.id).then((awards) => {
        setAwards(awards);
      });
    }
  }, [getAwards, topic]);

  useEffect(() => {
    handleAwards();
  }, [handleAwards]);

  useEffect(() => {
    scrollToRef();
  }, [scrollToRef]);

  return (
    <div ref={scrollRef}>
      {loadingAwards ? (
        <OptionLoader counter={4} />
      ) : (
        <OptionList>
          {awards.length > 0 ? (
            awards.map((award) => (
              <EntryOption
                key={award.id}
                kind="Premio"
                title={award.title}
                description={award.description}
                fileUrl={award.pdf && award.pdf.length > 0 && award.pdf[0].url}
                onSelect={() =>
                  onSelected({
                    id: award.id,
                    title: award.title,
                    hasSurvey: award.hasSurvey || false,
                  })
                }
              />
            ))
          ) : (
            <EntryOption
              kind="Premio"
              title="Sin premios disponibles"
              description="Esta temática todavía no tiene premios abiertos. Volvé a temáticas para elegir otra."
            />
          )}
        </OptionList>
      )}

      <OptionFooter>
        <BackToAnchorButton as="button" type="button" onClick={onBack}>
          ← Volver a temáticas
        </BackToAnchorButton>
      </OptionFooter>
    </div>
  );
}

export const Awards = memo(InternalAwards);
